import React from "react";

function GetMoneyBet() {
  return (
    <div className="Total">
      <div className="getCard">
        <h1>Recibe for award</h1>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Asperiores
          harum quidem, eos animi architecto delectus natus facere est atque.
          Tempore, quasi illo sed ipsum animi vel cum? Quas, soluta velit?
        </p>
        <button>Continue</button>
      </div>
    </div>
  );
}

export default GetMoneyBet;
